/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingListEntryPayer
 */
export interface CarveOutTrackingListEntryPayer {
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the CarveOutTrackingListEntryPayer interface.
 */
export function instanceOfCarveOutTrackingListEntryPayer(value: object): value is CarveOutTrackingListEntryPayer {
    return true;
}

export function CarveOutTrackingListEntryPayerFromJSON(json: any): CarveOutTrackingListEntryPayer {
    return CarveOutTrackingListEntryPayerFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntryPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CarveOutTrackingListEntryPayerToJSON(json: any): CarveOutTrackingListEntryPayer {
    return CarveOutTrackingListEntryPayerToJSONTyped(json, false);
}

export function CarveOutTrackingListEntryPayerToJSONTyped(value?: CarveOutTrackingListEntryPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

